import { FeatureFlagTypes } from "./featureFalgsTypes.enum";

export const RouteToFeatureFlagType: { [route: string]: FeatureFlagTypes } = {
    ai: FeatureFlagTypes.EnterpriseAiDashboard,
};
